import {
  Tooltip,
  type TooltipProps,
  Typography,
  type TypographyProps
} from '@mui/material'
import React, { type ElementType } from 'react'

/**
 * param `tooltipProps` is mandatory because an object with
 * at least { title: string } must be passed in for the tooltip to appear
 * (an empty string title won't render the tooltip)
 *
 * @example ```
 * const title = condition ? 'title' : ''
 * return <TruncatedTextWithTooltip tooltipProps={{ title }}>Text</TruncatedTextWithTooltip>
 * ```
 */
export const TruncatedTextWithTooltip: React.FC<
  Omit<TypographyProps, 'children'> & {
    component?: ElementType
    tooltipProps: Omit<TooltipProps, 'children'>
  }
> = ({ children, tooltipProps, ...rest }) => {
  return (
    <Tooltip arrow placement="top" {...tooltipProps}>
      <Typography noWrap {...rest}>
        {children}
      </Typography>
    </Tooltip>
  )
}
